import { AuthShell } from './features/auth/AuthShell'

export default function App() {
  return (
    <AuthShell />
  )
}
